import { gql } from "apollo-boost";

export const GET_APPLICABLE_COUPONS = gql`
  query consumerGetApplicableCoupons($bookingId: ID!) {
    consumerGetApplicableCoupons(bookingId: $bookingId) {
      offerId
      name
      code
      description
      discountValueType
      discountValue
      maxDiscountCap
      estimatedDiscountAmount
    }
  }
`;
